// extracted by mini-css-extract-plugin
export default {"fullWidth":"rh-z","hasStyledAspectRatio":"sh-z"};